interface Props {
  [key: string]: any
}

export default function HexEncyclopediaIcon(props: Props): React.ReactElement {
  const { pathClassName, gradientStart, gradientStop, colorMatrix, id, innerIconOpacity = 1, ...rest } = props
  const FilterId = id ? String(id).replace(/'/g, '') : Math.random().toString(36)

  return (
    <svg
      style={{ WebkitTransform: 'translate3d(0,0,0)' }} // Fix for Safari bug
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
      fill="none"
      viewBox="0 0 101 100"
    >
      <g filter={`url(#filter0_${FilterId})`}>
        <path
          d="M45.0209 3.65554C48.2913 1.92147 52.2087 1.92147 55.4791 3.65554L87.6677 20.7227C91.3184 22.6585 93.6012 26.4526 93.6012 30.5848V63.1247C93.6012 67.2568 91.3184 71.051 87.6677 72.9867L55.4791 90.0539C52.2087 91.788 48.2913 91.788 45.0209 90.0539L12.8323 72.9867C9.18156 71.051 6.89883 67.2568 6.89883 63.1247V30.5848C6.89883 26.4526 9.18157 22.6585 12.8323 20.7227L45.0209 3.65554Z"
          fill={`url(#paint0_${FilterId})`}
          shapeRendering="crispEdges"
        />
      </g>
      <path
        d="M79.834 31.5611V66.5813C79.834 68.1998 78.5224 69.5114 76.9039 69.5114H23.5956C21.9771 69.5114 20.6655 68.1998 20.6655 66.5813V31.5611C20.6655 30.6932 21.1347 29.8937 21.8911 29.4715L22.9115 28.9008C23.5448 28.547 24.3247 29.0044 24.3247 29.7296V60.1895C24.3247 61.9467 25.5972 63.444 27.331 63.7236L46.9522 66.9175C49.1356 67.2733 51.362 67.2733 53.5454 66.9175L73.1665 63.7236C74.9023 63.4421 76.1729 61.9448 76.1729 60.1895V29.7296C76.1729 29.0044 76.9528 28.547 77.5861 28.9008L78.6064 29.4715C79.3649 29.8957 79.834 30.6952 79.834 31.5611Z"
        fill="white"
        fillOpacity={innerIconOpacity}
      />
      <path
        d="M48.2615 65.2032L26.8733 61.5538C26.367 61.4678 25.9956 61.028 25.9956 60.5139V25.2572C25.9956 24.6805 26.4569 24.2094 27.0335 24.2016C30.638 24.1528 42.7453 24.5378 49.2173 31.4692C49.3972 31.6627 49.4949 31.9207 49.4949 32.1865V64.1633C49.4949 64.8162 48.9065 65.3127 48.2615 65.2032Z"
        fill="white"
        fillOpacity={innerIconOpacity}
      />
      <path
        d="M52.2368 65.2032L73.6251 61.5538C74.1313 61.4678 74.5027 61.028 74.5027 60.5139V25.2572C74.5027 24.6806 74.0414 24.2095 73.4648 24.2017C69.8603 24.1528 57.753 24.5379 51.281 31.4692C51.1012 31.6627 51.0034 31.9207 51.0034 32.1866V64.1633C51.0034 64.8162 51.5918 65.3127 52.2368 65.2032Z"
        fill="white"
        fillOpacity={innerIconOpacity}
      />

      <defs>
        <filter
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
          height="95"
          id={`filter0_${FilterId}`}
          width="85"
          x="8"
          y="1"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values={colorMatrix} />
          <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_1883_103692" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_1883_103692" mode="normal" result="shape" />
        </filter>
        <linearGradient gradientUnits="userSpaceOnUse" id={`paint0_${FilterId}`} x1="54" x2="53" y1="80" y2="0">
          <stop stopColor={gradientStart} />
          <stop offset="1" stopColor={gradientStop} />
        </linearGradient>
      </defs>
    </svg>
  )
}
